import styled from "styled-components";
import { ButtonBase, Box, Typography } from "@mui/material";

export const Container = styled(Box)`
  && {
    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px 0px;
    position: relative;
  }
`;

export const Text = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const GetStartedButton = styled(ButtonBase)`
  && {
    height: 50px;
    background: #f2753b;
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    padding: 0px 25px;
  }
`;
